import { createDraftSafeSelector } from '@reduxjs/toolkit'

import { RootState } from 'src/Redux'
import { SliceStatus } from 'src/Redux/types'

import { AudienceTiktokState } from '.'

const getState = (state: RootState): AudienceTiktokState =>
  state.scheduling.audienceTiktok
export const getIsTiktokAudienceLoading = createDraftSafeSelector(
  getState,
  ({ status }) => status === SliceStatus.Loading || status === SliceStatus.Idle,
)

export const getIsTiktokAudienceRequestNeeded = createDraftSafeSelector(
  getState,
  ({ status }) =>
    status !== SliceStatus.Loading && status !== SliceStatus.Succeeded,
)

export const getEstimatedTiktokViews = createDraftSafeSelector(
  getState,
  ({ maxViews, minViews }) => ({ maxViews, minViews }),
)

export const getEstimatedTiktokVideos = createDraftSafeSelector(
  getState,
  ({ estimatedMinVideos, estimatedMaxVideos }) => ({
    estimatedMinVideos,
    estimatedMaxVideos,
  }),
)

export const getTiktokPrice = createDraftSafeSelector(
  getState,
  ({ price }) => price,
)

export const getIsEnoughBalanceForTiktok = createDraftSafeSelector(
  (state: RootState) => ({
    balance: Number(state?.authentication?.user?.user?.balance),
    price: getTiktokPrice(state),
  }),
  ({ price, balance }) => balance >= price && price > 0,
)
